import * as actionTypes from "./actionTypes";

export const addSupplierAction = (supplierData) => {
  return { type: actionTypes.ADD_SUPPLIER, supplierData };
};

export const addSupplierSuccessAction = (suppliers) => {
  return { type: actionTypes.ADD_SUPPLIER_SUCCESS, suppliers };
};

export const editSupplierAction = (supplierData) => {
  return { type: actionTypes.EDIT_SUPPLIER, supplierData };
};

export const editSupplierSuccessAction = (suppliers) => {
  return { type: actionTypes.EDIT_SUPPLIER_SUCCESS, suppliers };
};

export const deleteSupplierAction = (supplierData) => {
  return { type: actionTypes.DELETE_SUPPLIER, supplierData };
};

export const deleteSupplierSuccessAction = (suppliers) => {
  return { type: actionTypes.DELETE_SUPPLIER_SUCCESS, suppliers };
};

export const getSuppliersAction = (storeId) => {
  return { type: actionTypes.GET_SUPPLIERS, storeId };
};

export const getSuppliersSuccessAction = (suppliers) => {
  return { type: actionTypes.GET_SUPPLIERS_SUCCESS, suppliers };
};
